import { render, staticRenderFns } from "./collaboration.vue?vue&type=template&id=fc5c882e&"
import script from "./collaboration.vue?vue&type=script&lang=js&"
export * from "./collaboration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports